var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdcVirtual = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0263,
    cy: 24,
    r: 23.0263,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9026 15.7769C25.6276 15.7769 27.8371 17.9855 27.8372 20.7105C27.8372 23.4356 25.6277 25.6451 22.9026 25.6451C20.1776 25.645 17.969 23.4355 17.969 20.7105C17.9691 17.9855 20.1776 15.777 22.9026 15.7769Z",
    stroke: "#00BCDA",
    strokeWidth: 1.97368
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5874 21.944L14.7261 22.7672L14.814 23.2272C15.2693 25.3449 16.3519 27.0892 18.0698 28.3365L18.4478 28.5963L18.4507 28.5983L18.7153 28.7633C20.0456 29.5597 21.5914 29.9398 23.1733 29.9518C26.8206 29.7814 30.2101 27.3856 31.0649 22.9078L31.2183 22.1051H37.6968L37.5659 23.2086C37.0584 27.4897 35.1676 31.0318 31.6606 33.5426C26.8084 37.0278 21.4926 37.4131 16.1704 34.8014L16.1655 34.7985C11.0922 32.2672 8.4188 27.1458 8.2251 22.9772L8.17627 21.944H14.5874Z",
    stroke: "#00BCDA",
    strokeWidth: 1.97368
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdcVirtual);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edc-virtual.6db7f141546664414edc03c2f31bfbdb.svg";